/**
 * @author Muhammad Omran
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2020-10-21
 * @description Implementation of the GraphQL query to retrieve a featured person details.
 * @filename featured-person-query.tsx
 */
import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL query to retrieve the featured person with an id.
 *
 * @type {GraphQLTaggedNode}
 */
export const FEATURED_PERSON_QUERY: GraphQLTaggedNode = graphql`
  query featuredPersonQuery($id: ID!) {
    person(id: $id) {
      hasErrors
      person {
        __typename
        description
        fullName
        landingPageUrl
        revision
        id
        previews {
          count
          edges {
            cursor
            preview {
              link
              kind
              mediaAsset {
                id
                files {
                  id
                  name
                  path
                }
                topLevelMediaType {
                  kind
                  label
                }
              }
            }
          }
        }
        responsibility
        websiteUrl
      }
    }
  }
`;
